import { Component, OnInit, ViewChild , Inject} from '@angular/core';
import { Router, ActivatedRoute, Params, RouterLink} from '@angular/router';
import {NgForm, FormBuilder, FormGroup, FormControl} from '@angular/forms';
import { DeletePopupComponent } from '../Popups/delete-popup/delete-popup.component';
import { MobileNavService } from '../../shared/services/mobile-nav.service';
import { OrganizationService } from '../../shared/services/organization.service';
import { Organization } from '../update/mockOrganization';
import { error } from 'selenium-webdriver';
import { AssociateService } from '../../associate/shared/services/associate.service';
import { AuthService } from '../../shared/services//auth/auth.service';
import { StaticValueService } from '../../shared/services/static-value.service';
import { MatSnackBar, MatDialog, MatDatepickerModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ImageCropDialogComponent } from '../update/update.component';
import { NotificationService } from '../../shared/services/notification.service';
import { DisapprovalComponent } from '../../shared/components/disapproval/disapproval.component';
import { ToastService } from '../../shared/services/toast.service';
import {Location} from '@angular/common';
import { Configuration } from '../../app.constants';
import { Chart } from 'angular-highcharts';
import { isString } from '@ng-bootstrap/ng-bootstrap/util/util';
import {Sort} from '@angular/material';
import { Ng2ImgToolsService } from 'ng2-img-tools';

declare let Croppie;
declare let document;
import * as moment from 'moment';
import { CommonDbService } from '../../shared/services/common-db.service';
// import {MAT_MOMENT_DATE_FORMATS, MomentDateAdapter} from '@angular/material-moment-adapter';
// import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';





@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']

})
export class ProfileComponent implements OnInit {

  public tabs= 'profile';

  @ViewChild('myForm')
  public myForm: NgForm ;

  @ViewChild('myForm1')
  public myForm1: NgForm ;

  public businessModelDistributionCheckBox: Boolean = false;
  public businessModelProjectBasedCheckBox: Boolean = false;
  public businessModelKeyAccountsCheckBox: Boolean = false;

  cutomerSalesChart;
  productSalesChart;
  salesData: Boolean = false;
  productData: Boolean = false;
  public customerSales: Boolean = true;
  public productSales: Boolean = true;
  public hrIds = [];
  public pageSizeOptionsHRTab = [5, 10, 25, 100];
  public pageSizeHRTab = 5;
  public selectedParentCompany: any;
  public allOrganizations;

  checkEmptyDataSalesChart() {
    this.customerSalesArray.forEach(val => {
      if(val.y !== 0) {
        this.salesData = true;
      }
    })
  }

  checkEmptyDataProductChart() {
    this.productSalesArray.forEach(val => {
      if(val.y !== 0) {
        this.productData = true;
      }
    })
  }

  public customerSalesChartData  = {
    chart: {
        type: 'pie',
        height: 200
    },
    title: {
        text: ''
    },
    credits: {
        enabled: false
    },
    legend: {
      align: 'right',
      layout: 'vertical',
      verticalAlign: 'middle',
      x: -100,
      y: 0
  },
    plotOptions: {
        pie: {
            colors: ['#4E97F6', '#567CE5', '#4466C0', '#7CB4F3'],
            dataLabels: {
                enabled: false
            }
        }
    },
    series: [{
        name: 'Customer Sales',
        data: [1, 1 , 1 , 1],
        innerSize: '80%',
        showInLegend: true
      //   dataLabels: {
      //     formatter: function () {
      //         // display only if larger than 1
      //         return '<b>' + this.point.name + ':</b> ';
      //     }
      // },
    }]
};
private productSalesChartData  = {
  chart: {
      type: 'pie',
      height: 200,
  },
  title: {
      text: ''
  },
  legend: {
    align: 'right',
    layout: 'vertical',
    verticalAlign: 'top',
    x: 53,
    y: 0
},
  credits: {
      enabled: false
  },
  plotOptions: {
      pie: {
          colors: ['#3cc6ed', '#c32d26', '#0e9748', '#0572b8', '#194689', '#f7922e', '#f0552c', '#ee3463', '#77787b'],
          dataLabels: {
              enabled: false
          }
      }
  },
  series: [{
      name: 'Product Sales',
      data: [1, 1 , 1 , 1],
      innerSize: '80%',
      showInLegend: true
    //   dataLabels: {
    //     formatter: function () {
    //         // display only if larger than 1
    //         return '<b>' + this.point.name + ':</b> ';
    //     }
    // },
  }]
};

  // stats
  public stats = {};
  public genderStats = {};
  // ACL variables
  public isAdmin: Boolean = false;
  public isHrOrCompanyLeader: Boolean = false;
  public isAssociate: Boolean = false;
  public currentUserId: string;
  public legalEntityList: any;

  // saving Id's of companyLeaders'
  public originalHrLeaderId: string;
  public originalFinanceLeaderId: string;
  public originalDigitalLeaderId: string;
  public originalCompanyLeaderId: string;



  public staticDDlist = {};
  public organizationId: string;
  public action: string;
  public disapprovalComments: string;
  public serverApiUrl;

  // Type ahead droDown validation Booleans
  public parentCompanyValidation: Boolean = true;
  public companyLeaderValidation: Boolean = true;
  public financeLeaderValidation: Boolean = true;
  public digitalLeaderValidation: Boolean = true;

  // Card Edit Clones
  public tempBase64Img: string;
  public company: any;
  public companyLeaderShip: any;
  public companyOverview: any;
  public companySize: any;
  public sitesValidation: any
  public legalEntitiesValidation: any;

  // validated card
  public validatedCompany: any = JSON;
  public validatedCompanyLeaderShip: any = JSON;
  public validatedCompanyOverview: any = JSON;
  public validatedCompanySize: any = JSON;



  // typeAhead autocomplete
  public keyCounter = 0;
  public keyCounterOrg = 0;
  // for getting associates for typeAhead drop-downs
  public autoCompleteOrganization: any = [];
  public autoCompleteAssociateHrLeader: any;
  public autoCompleteAssociateCompanyleader: any;
  public autoCompleteAssociateDigitalLeader: any;
  public autoCompleteAssociateFinanceLeader: any;
  public autoCompleteAssociateLegalLeader: any;
  public autoCompleteAssociateItLeader: any;
  public autoCompleteAssociateMarketingLeader: any;
  public autoCompleteAssociatesupplyChainLeader: any;
  public autoCompleteAssociatecategoryManager: any;
  public autoCompleteAssociateComplianceOfficer: any;
  public autoCompleteAssociateHrTeam :any;
  public associateSearchHrTeam: string;
  public selectedAssociates = [];

  public fieldChanges = [];
  public currencies = [];
  public currencyToSymbolMap: any;

  public canValidate: Boolean = false;
  public viewMode: Boolean = false;
  // Card Edit Mode Boolean's
  public companyEdit: Boolean = false;
  public companyLeaderShipEdit: Boolean = false;
  public companyOverviewEdit: Boolean = false;
  public companySizeEdit: Boolean = false;
  // arrays for displaying comma separated strings
  public industrySegmentArray = [];
  public marketsServedArray = [];
  public customerTypesArray = [];
  public errors: any;
  // original object
  organization: any;
  // hiding charts when no data
  public customerSalesVisibility;
  public productSalesVisibility;
  public startMemberIndex= 0 ;

  public customerSalesArray = [];
  public productSalesArray = [];

  public isHrLeader : any = false;
  public isCompanyLeader: any = false;
  constructor( public dialog: MatDialog ,
              public mobileNav: MobileNavService,
              public organizationService: OrganizationService,
              public route: ActivatedRoute,
              public router: Router,
              public ng2ImgToolsService: Ng2ImgToolsService,
              public associateService: AssociateService,
              public snackbar: MatSnackBar,
              public authService: AuthService,
              public staticDataService: StaticValueService,
              public notificationService: NotificationService,
              public _location: Location,
              public toastService: ToastService,
              public commonDbService:CommonDbService,
              public config: Configuration) {
                //this.cutomerSalesChart = new Chart(this.salesChartData);
               }

  onClickMe() {
        this.mobileNav.showSideNav();
    }

  setPageSizeOptions(setPageSizeOptionsInput: string) {
      this.pageSizeOptionsHRTab = setPageSizeOptionsInput.split(',').map(str => +str);
  }

    assignCardObjects() {
      if (!this.selectedAssociates) {
        this.selectedAssociates = [];
      }
      // setting Timezone independent dates
      if (this.organization.companySize.joinDate) {
        this.organization.companySize.joinDate = moment
        .parseZone(this.organization.companySize.joinDate, 'YYYY-MM-DD').zone(0).format();
      }
      // -------
        this.company =  JSON.parse(JSON.stringify( this.organization['company']));
        this.companyLeaderShip =  JSON.parse(JSON.stringify( this.organization['companyLeaderShip']));
        this.companyOverview =  JSON.parse(JSON.stringify( this.organization['companyOverview']));
        this.companySize =  JSON.parse(JSON.stringify(this.organization['companySize']));
        // these variables need to be accessed by child components
        this.organizationService.organizationId = this.organizationId;
        this.organizationService.hrLeaderId = this.organization.companyLeaderShip.hrLeader.id;
        this.organizationService.companyLeaderId = this.organization.companyLeaderShip.companyLeader.id;
        this.organizationService.companyName = this.organization.company.companyName;
        this.organizationService.hrTeamIds = this.organization.companyLeaderShip.hrTeamIds;

        this.organizationService.getLastValidatedCard(this.organization._id, 'company').subscribe(card => {
          if (card) {
            this.validatedCompany = card
          } else {
            this.validatedCompany = this.company;
          }
        },err => {
          this.validatedCompany = this.company;
        });
        this.organizationService.getLastValidatedCard(this.organization._id, 'companyLeaderShip').subscribe(card => {
          if (card) {
            this.validatedCompanyLeaderShip = card
          }else {
            this.validatedCompanyLeaderShip = this.companyLeaderShip;
          }
        },err => {
          this.validatedCompanyLeaderShip = this.companyLeaderShip;
        });
        this.organizationService.getLastValidatedCard(this.organization._id, 'companyOverview').subscribe(card => {
          if (card) {
            this.validatedCompanyOverview = card
          }else {
            this.validatedCompanyOverview = this.companyOverview;
          }
        },err => {
          this.validatedCompanyOverview = this.companyOverview;
        });
        this.organizationService.getLastValidatedCard(this.organization._id, 'companySize').subscribe(card => {
          if (card) {
            this.validatedCompanySize = card
          }else {
            this.validatedCompanySize = this.companySize;
          }
        },err => {
          this.validatedCompanySize = this.companySize;
        });

        if (this.companyOverview.businessModel.indexOf('Distribution') > -1) {
          this.businessModelDistributionCheckBox = true;
        } if (this.companyOverview.businessModel.indexOf('Project Based') > -1) {
          this.businessModelDistributionCheckBox = true;
        } if (this.companyOverview.businessModel.indexOf('Key Accounts') > -1) {
          this.businessModelDistributionCheckBox = true;
        }
        this.refreshCharts();
    }

    setTimeZone() {
      this.organization.companySize.joinDate = moment(this.organization.companySize.joinDate, 'YYYY-MM-DDTHH:mm:ss').format()
    }
    refreshCharts() {
      this.customerSalesChartData.series[0].data = [];
      this.customerSalesArray = [];
      this.productSalesArray = [];
      this.salesArray();
      this.customerSalesArray.forEach(val => {
        if(val.y) {
          val.y = Number(val.y.toFixed(2))
        }
      });
      this.productSalesArray.forEach(val => {
        if(val.y) {
          val.y = Number(val.y.toFixed(2))
        }
      })
      this.customerSalesChartData.series[0].data = JSON.parse(JSON.stringify(this.customerSalesArray));
      this.cutomerSalesChart = new Chart(this.customerSalesChartData);
      this.productSalesChartData.series[0].data = [];
      this.productSalesChartData.series[0].data = JSON.parse(JSON.stringify(this.productSalesArray));
      this.productSalesChart = new Chart(this.productSalesChartData);
      this.checkEmptyDataProductChart();
      this.checkEmptyDataSalesChart();

    }

    salesArray() {
      this.customerSalesArray.push({name: 'Industry', y: this.organization['companySize'].customerSales.industry});
      this.customerSalesArray.push({name: 'Power Distribution' , y: this.organization['companySize'].customerSales.infrastructure});
      this.customerSalesArray.push({name: 'Installers' , y: this.organization['companySize'].customerSales.installers});
      this.customerSalesArray.push({name: 'Others' , y: this.organization['companySize'].customerSales.others});
      // product sales
      this.productSalesArray.push({name: 'Building Automation And Construction',
      y : this.organization['companySize'].productSales.buildingAutomationAndConstruction});
      this.productSalesArray.push({name: 'Cables And Wires', y: this.organization['companySize'].productSales.cablesAndWires});
      this.productSalesArray.push({name: 'HVAC And Renewable Energy',
      y: this.organization['companySize'].productSales.hvacAndRenewableEnergy});
      this.productSalesArray.push({name: 'Industrial Automation',
      y: this.organization['companySize'].productSales.industrialAutomation});
      this.productSalesArray.push({name: 'Power Distribution', y: this.organization['companySize'].productSales.infrastructure});
      this.productSalesArray.push({name: 'Lighting', y: this.organization['companySize'].productSales.lighting});
      this.productSalesArray.push({name: 'Safety Tools And Engineering Supplies',
      y :this.organization['companySize'].productSales.safetyToolsAndEngineeringSupplies});
      this.productSalesArray.push({name: 'Specialities', y : this.organization['companySize'].productSales.specialities});
      this.productSalesArray.push({name: 'Others', y : this.organization['companySize'].productSales.others });
      let productSalecount = 0, customerSalecount= 0;
      this.productSalesArray.forEach(productSale => {
        if(productSale['y'] === null) {
          ++productSalecount;
        }
      });
      this.customerSalesArray.forEach(customerSale => {
        if(customerSale['y'] === null) {
          ++customerSalecount;
        }
      });
      if (productSalecount === this.productSalesArray.length){
        this.productSalesVisibility = false;
      } else {
        this.productSalesVisibility = true;
      }
      if (customerSalecount === this.customerSalesArray.length){
        this.customerSalesVisibility = false;
      } else {
        this.customerSalesVisibility = true;
      }
    }

  calculatePhysicalSiteStats(){
      this.stats['physicalSiteStats'].forEach(stats => {
        if(stats._id === 'Office'){
          this.stats['physicalSiteStats']['Office'] = stats.count
        } else if (stats._id === 'Store'){
          this.stats['physicalSiteStats']['Store'] = stats.count
        } else if (stats._id === 'Sales Office'){
          this.stats['physicalSiteStats']['Sales Office'] = stats.count
        } else if (stats._id === 'Warehouse'){
          this.stats['physicalSiteStats']['Warehouse'] = stats.count
        } else if (stats._id === 'On Site Stock'){
          this.stats['physicalSiteStats']['On Site Stock'] = stats.count
        }
      });
  }
  ngOnInit() {
    this.organizationService.getOrganization().subscribe((data) => {
            this.allOrganizations = data;
        }, (error) => { });
    this.serverApiUrl = this.config.StaticImageUrl;
    this.staticDataService.getStaticValues().then(staticData => {
        this.currencies = Object.keys(staticData.staticDD.currencies);
        this.currencyToSymbolMap = staticData.staticDD.currencies;
    });
    this.organization =  JSON.parse(JSON.stringify( this.route.snapshot.data['organization']['data'][0]));
    this.hrIds = Object.assign([],this.organization.companyLeaderShip.hrTeamIds);
    this.hrIds.push(this.organization.companyLeaderShip.hrLeader.id)
    this.hrIds.push(this.organization.companyLeaderShip.companyLeader.id)
    this.selectedAssociates = this.route.snapshot.data['organization']['hrTeamAssociates'];
    this.stats =  this.route.snapshot.data['organization']['siteStats'];
    this.calculatePhysicalSiteStats();
    this.genderStats =   this.route.snapshot.data['organization']['genderStats'];
    this.legalEntityList = this.organization.legalEntities;
    // this.setTimeZone();
    this.assignCardObjects();
     // this.sitesValidation =  JSON.parse(JSON.stringify( this.organization['sitesValidation']));
    // this.legalEntitiesValidation =  JSON.parse(JSON.stringify(this.organization['legalEntitiesValidation']));
    // ------------------------------------------------------------------
    // public validatedCompany: any;
    // public validatedCompanyLeaderShip: any;
    // public validatedCompanyOverview: any;
    // public validatedCompanySize: any;


    this.currentUserId = this.authService.user.associateId;
    this.route.params.subscribe(params => {
      this.organizationId = params['id'];
      this.organizationService.organizationId = this.organizationId;
      this.organizationService.getOrganization(this.organizationId).subscribe((data) => {
        this.organization = data['data'][0];
        this.selectedAssociates = data['hrTeamAssociates'];
        this.stats = data['siteStats'];
        this.calculatePhysicalSiteStats();
        this.genderStats = data['genderStats'];
        // saving Id's of company Leaders
        this.originalHrLeaderId = this.organization.companyLeaderShip.hrLeader.id;
        this.originalCompanyLeaderId = this.organization.companyLeaderShip.companyLeader.id;
        this.originalFinanceLeaderId = this.organization.companyLeaderShip.financeLeader.id;
        this.originalDigitalLeaderId = this.organization.companyLeaderShip.digitalLeader.id;
        this.assignCardObjects();
        this.tabs = params['tab'] ? params['tab'] : this.tabs;
      }, (error) => {});
      // copy values from original object to card objects
      this.action = params['action'];
      if (this.action === 'edit') {
        this.canValidate = false;
      } else if (this.action === 'validate') {
        this.canValidate = true;
      } else if (this.action === 'view') {
        this.viewMode = true;
      }
    });
    this.staticDDlist = this.staticDataService.staticData.staticDD
    this.errors = this.staticDataService.errors;
    if  (this.authService.user.role === 'Admin') {
      this.isHrOrCompanyLeader = false;
      this.isAdmin = true;
      this.isAssociate = false;
    } else if (this.currentUserId === this.organization.companyLeaderShip.companyLeader.id || this.currentUserId === this.organization.companyLeaderShip.hrLeader.id || (this.organization.companyLeaderShip.hrTeamIds.indexOf(this.currentUserId) > -1) ) {
       this.isHrOrCompanyLeader = true;
       this.isAdmin = false;
       this.isAssociate = false;
   } else  {
     this.isHrOrCompanyLeader = false;
     this.isAdmin = false;
     this.isAssociate = true;
   }

   if(this.currentUserId === this.organization.companyLeaderShip.hrLeader.id) {
     this.isHrLeader = true;
   }
   if(this.currentUserId === this.organization.companyLeaderShip.companyLeader.id) {
    this.isCompanyLeader = true;
  }
    // split comma separated values into arrays
    this.industrySegmentArray = this.organization.companyOverview.industrySegment.split(',');
    this.marketsServedArray = this.organization.companyOverview.marketsServed.split(',');
    this.customerTypesArray = this.organization.companyOverview.customerTypes.split(',');
  }

  // save individual card
  save(cardObj: string, editVariable: string) {
    this.fieldChanges = [];
    this.organizationService.getLastValidatedCard(this.organization._id, cardObj).subscribe(card => {
      if (card) {
          this.detectChanges(card, this[cardObj]);
      } else {
          this.detectChanges(this.organization[cardObj], this[cardObj]);
      }
      this[cardObj].validated = 1;
      if (this.isAdmin) {
        this[cardObj].validated = 2;
      } else {
        this[cardObj].validated = 1;
      }
      this.businessModelArray();
      // tslint:disable-next-line:max-line-length
      this[cardObj].lastEditedBy.name = this.authService.user.isProxyUser ? this.authService.user.name + ` (${this.authService.user.proxyUser.fullName})` : this.authService.user.name;
      this[cardObj].lastEditedBy.id = this.authService.user.associateId;
      this[cardObj].lastEditedBy.time = new Date();
      this.organization.lastEdited.push(this[cardObj].lastEditedBy);
      this.organization[cardObj] =  JSON.parse(JSON.stringify(this[cardObj]));
      if ( cardObj === 'companyOverview') {
        this.industrySegmentArray = this.organization.companyOverview.industrySegment.split(',');
        this.marketsServedArray = this.organization.companyOverview.marketsServed.split(',');
        this.customerTypesArray = this.organization.companyOverview.customerTypes.split(',');
      }
      // If any card is edited and saved then validated property should be set to pending for whole organization
      this.validateOrganization();

      this.update('edit', false, cardObj);
      this[editVariable] = false;

    }, error => {
      this[cardObj].validated = 1;
      if (this.isAdmin) {
        this[cardObj].validated = 2;
      } else {
        this[cardObj].validated = 1;
      }
      this.businessModelArray();
      // tslint:disable-next-line:max-line-length
      this[cardObj].lastEditedBy.name = this.authService.user.isProxyUser ? this.authService.user.name + ` (${this.authService.user.proxyUser.fullName})` : this.authService.user.name;
      this[cardObj].lastEditedBy.id = this.authService.user.associateId;
      this[cardObj].lastEditedBy.time = new Date();
      this.organization.lastEdited.push(this[cardObj].lastEditedBy);
      this.organization[cardObj] =  JSON.parse(JSON.stringify(this[cardObj]));
      if ( cardObj === 'companyOverview') {
        this.industrySegmentArray = this.organization.companyOverview.industrySegment.split(',');
        this.marketsServedArray = this.organization.companyOverview.marketsServed.split(',');
        this.customerTypesArray = this.organization.companyOverview.customerTypes.split(',');
      }
      // If any card is edited and saved then validated property should be set to pending for whole organization
      this.validateOrganization();
      this.update('edit', false, cardObj);
      this[editVariable] = false;
  });
    // this.detectChanges(this.organization[cardObj], this[cardObj]);
    // this[cardObj].validated = 1;
    // if (this.isAdmin) {
    //   this[cardObj].validated = 2;
    // } else {
    //   this[cardObj].validated = 1;
    // }
    // this.businessModelArray();
    // // tslint:disable-next-line:max-line-length
    // this[cardObj].lastEditedBy.name = this.authService.user.isProxyUser ? this.authService.user.name + ` (${this.authService.user.proxyUser.fullName})` : this.authService.user.name;
    // this[cardObj].lastEditedBy.id = this.authService.user.associateId;
    // this[cardObj].lastEditedBy.time = new Date();
    // this.organization.lastEdited.push(this[cardObj].lastEditedBy);
    // this.organization[cardObj] =  JSON.parse(JSON.stringify(this[cardObj]));
    // if ( cardObj === 'companyOverview') {
    //   this.industrySegmentArray = this.organization.companyOverview.industrySegment.split(',');
    //   this.marketsServedArray = this.organization.companyOverview.marketsServed.split(',');
    //   this.customerTypesArray = this.organization.companyOverview.customerTypes.split(',');
    // }
    // // If any card is edited and saved then validated property should be set to pending for whole organization
    // this.validateOrganization();

    // this.update('edit', false, cardObj);
    // this[editVariable] = false;
  }
  // edit individual card
  edit(cardObj: string, editVariable: string, editMode: boolean) {
    this[editVariable] = editMode;
    this.allOrganizations.forEach(element => {
      if(element._id == this.organization.company.parentCompany['id']) {
        this.selectedParentCompany = element;
      }
    });
    if ( !editMode ) {
      this[cardObj] = JSON.parse(JSON.stringify(this.organization[cardObj]));
    }
  }
  // validate individual cards
  validate(cardObj: string, validateMode: Boolean) {
    if ( validateMode === false ) {
      let dialogRef = this.dialog.open(DisapprovalComponent, {
          width: '500px',
        });
        dialogRef.afterClosed().subscribe(res => {
          if ( res ) {
            this[cardObj].validated = validateMode ? 2 : 0 ;
            this.disapprovalComments = res;
            this.organization[cardObj] = Object.assign({}, this[cardObj]) ;
            // tslint:disable-next-line:max-line-length
            this.organization[cardObj].lastValidatedBy.name = this.authService.user.isProxyUser ? this.authService.user.name + ` (${this.authService.user.proxyUser.fullName})` : this.authService.user.name;
            this.organization[cardObj].lastValidatedBy.id = this.authService.user.associateId;
            this.organization[cardObj].lastValidatedBy.time = new Date();
              this.validateOrganization();
              this.update('validate', validateMode,cardObj);
          }
      });
    } else {
      this[cardObj].validated = validateMode ? 2 : 0 ;
      this.organization[cardObj] = Object.assign({}, this[cardObj]) ;
      // tslint:disable-next-line:max-line-length
      this.organization[cardObj].lastValidatedBy.name = this.authService.user.isProxyUser ? this.authService.user.name + ` (${this.authService.user.proxyUser.fullName})` : this.authService.user.name;
      this.organization[cardObj].lastValidatedBy.id = this.authService.user.associateId;
      this.organization[cardObj].lastValidatedBy.time = new Date();
      this.validateOrganization();
      this.update('validate', validateMode, cardObj);
    }
  }
  // validate sites and legal Entities
  validateSitesAndEntities(field: string, validateMode: Boolean) {
    this[field].validated = validateMode ? 2 : 0;
    // tslint:disable-next-line:max-line-length
    this[field].sitesValidatedBy.name = this.authService.user.isProxyUser ? this.authService.user.name + ` (${this.authService.user.proxyUser.fullName})` : this.authService.user.name;
    this[field].sitesValidatedBy.id = this.authService.user.associateId;
    this[field].sitesValidatedBy.time = new Date();
  }

  // persist the changes to database
  update(action: string, validateMode?: Boolean, cardname?:any,hrTeamMemberId? :string) {
    if (this.organization.companySize.joinDate) {
      this.organization.companySize.joinDate = moment(new Date(this.organization.companySize.joinDate))
        .format('YYYY-MM-DD');
    }
    this.organization.updatedCardName = cardname;
    // In case of HR team change send an identifier so  backend can know if there has been change in HR Team
    if (cardname === 'hrTeam') {
      this.organization['hrTeamChanged'] = true;
      this.organization.updatedCardName = undefined;
    }
    this.organizationService.updateOrganization(this.organization).subscribe((data) => {
      if (action === 'edit') {
        this.refreshCharts();
        if (this.isAdmin === false) {
              // send notification to admin for validation in action center
              let formalCardName = this.getFormalCardName(cardname);
              this.notificationService.sendActionMessage('Admin', `Approve ${this.organization.company.companyName}'s profile
              changes for ${formalCardName} `,
            // tslint:disable-next-line:max-line-length
            `/home/organization/profile/validate/${this.organizationId}`, 'Validation', 'Organization',2,0,this.organizationId,cardname,
            this.fieldChanges, this.organization.company.avatarUrl);
        }
         // send notification to HR Leader and Company Leader
         if ( this.authService.user.associateId === this.organization.companyLeaderShip.companyLeader.id ||
          this.authService.user.role === 'Admin' ) {
          this.notificationService.sendNotification(this.organization.companyLeaderShip.hrLeader.id,
            `<b>${this.organization.company.companyName}</b> has been updated`, 'Organization',
            `home/organization/profile/view/${this.organizationId}`);
        }
        if ( this.authService.user.associateId === this.organization.companyLeaderShip.hrLeader.id ||
            this.authService.user.role === 'Admin' ) {
          this.notificationService.sendNotification(this.organization.companyLeaderShip.companyLeader.id,
          `<b>${this.organization.company.companyName}</b> has been updated`, 'Organization',
          `home/organization/profile/view/${this.organizationId}`);
        }
      // send notifications to company Leaders if any leader has been changed
        if (this.originalHrLeaderId !== this.organization.companyLeaderShip.hrLeader.id) {
          this.sendNotificationToCompanyLeaders(`Company  ${this.organization.company.companyName}'s HR Leader is now
           ${this.organization.companyLeaderShip.hrLeader.name}`, `home/organization/profile/view/${this.organizationId}`);
           // replace original leader field with new Id
           this.originalHrLeaderId = this.organization.companyLeaderShip.hrLeader.id;
           this.newsGenerate('HR Leader Change',`Hey ${this.company.companyName} have new HR leader, welcome him.`,this.hrIds)
          }
        if (this.originalCompanyLeaderId !== this.organization.companyLeaderShip.companyLeader.id) {
          this.sendNotificationToCompanyLeaders(`Company  ${this.organization.company.companyName}'s Company Leader is now
          ${this.organization.companyLeaderShip.companyLeader.name}`, `home/organization/profile/view/${this.organizationId}`);
          // replace original leader field with new Id
          this.originalCompanyLeaderId = this.organization.companyLeaderShip.companyLeader.id;
          this.newsGenerate('Company Leader Change',`Hey ${this.company.companyName} have new Company leader, welcome him.`,this.hrIds)
        }
         if (this.originalFinanceLeaderId !== this.organization.companyLeaderShip.financeLeader.id) {
          if (this.organization.companyLeaderShip.financeLeader.id !== '') {
            this.sendNotificationToCompanyLeaders(`Company  ${this.organization.company.companyName}'s Finance Leader is now
            ${this.organization.companyLeaderShip.financeLeader.name}`, `home/organization/profile/view/${this.organizationId}`);
            // replace original leader field with new Id
          this.originalFinanceLeaderId = this.organization.companyLeaderShip.financeLeader.id;
          this.newsGenerate('Finance Leader Change',`Hey ${this.company.companyName} have new Finance leader, welcome him.`,this.hrIds)

          }
        }
        if (this.originalDigitalLeaderId !== this.organization.companyLeaderShip.digitalLeader.id) {
          if (this.organization.companyLeaderShip.digitalLeader.id !== '') {
            this.sendNotificationToCompanyLeaders(`Company  ${this.organization.company.companyName}'s Digital Leader is now
            ${this.organization.companyLeaderShip.digitalLeader.name}`, `home/organization/profile/view/${this.organizationId}`);
             // replace original leader field with new Id
          this.originalDigitalLeaderId = this.organization.companyLeaderShip.digitalLeader.id;
          this.newsGenerate('Digital Leader Change',`Hey ${this.company.companyName} have new Digital leader, welcome him.`,this.hrIds)
          }
        }
      } else if (action === 'validate') {
        if (validateMode === true) {
          this.sendNotificationToCompanyLeaders(`Company ${this.organization.company.companyName}'s updated details have been approved`,
          `home/organization/profile/view/${this.organizationId}`);
          } else {
            this.sendNotificationToCompanyLeaders(`Company ${this.organization.company.companyName}'s updated details have been rejected,
            because: ${this.disapprovalComments}`, `home/organization/profile/view/${this.organizationId}`);
          }
      }
      if (cardname === 'hrTeam') {
        this.notificationService.sendNotification(hrTeamMemberId,
          `You have been added to HR team of <b>${this.organization.company.companyName}</b>`, 'Organization',
          `home/organization/profile/view/${this.organizationId}`);
      }

      this.toastService.success();
    }, ( error) => {
      this.toastService.error(this.errors.Server['501']);
    });
  }


  newsGenerate(subject,message,ids){
    let data = {
    subject : subject,
    message : message,
    category :"Employee Announcement",
    status : 'Pending',
    lastUpdated :{}
    }
    // this.commonDbService.publishNews(data,[]).subscribe(response =>{
    //   console.log(response)
    // },error => {
    //   console.log(error)
    // });
  }
  // Open delete pop Up
  openDialog(action: string): void {
    const dialogRef = this.dialog.open(DeletePopupComponent, {
      width: '400px',
      data: {name : 'Company', length: 0}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'Cancel') {
      } else if (result === 'Proceed') {
        if (action === 'archive') {
        this.markAsInactive();
        } else if (action === 'unArchive') {
          this.unarchive();
        }
      }
    });
  }
  // mark organization as Inactive
  markAsInactive() {
   this.organization.active = false;
   this.organization['lastArchivedBy'] = Object.assign({}, { 'name': this.authService.user.name, 'id':
   this.authService.user.associateId, time: new Date() });
   this.organization.lastArchived.push({ 'name': this.authService.user.name, 'id':
   this.authService.user.associateId, time: new Date() });
   this.organizationService.updateOrganization(this.organization).subscribe((data) => {
    this.router.navigate(['/home/organization/organization-list']);
    this.sendNotificationToCompanyLeaders(`Company ${this.organization.company.companyName} is now archived` , 'home/associate/feed');
    this.toastService.success();
    }, (error) => {
    this.toastService.error(this.errors.Server['501']);
    });
  }

  // Unarchive Organization
  unarchive() {
    this.organization.active = true ;
    this.organizationService.updateOrganization(this.organization).subscribe((data) => {
      this.router.navigate(['/home/organization/organization-list']);
      this.snackbar.open('Company has been unarchived', '', {
        duration: 3000
      });
    }, (error) => {
      this.snackbar.open('Company could not be unarchived', '', {
        duration: 3000
      });
    })
  }

  // Type Ahead drop downs and their click handlers
// validation of typeAhead drop Downs
validateParentCompany() {
  let parentObj: any = this.autoCompleteOrganization.filter((org) => {
    return org.company.companyName === this.company.parentCompany.name;
  } );
  if ( parentObj.length === 0) {
    this.parentCompanyValidation = false;
  } else {
    this.parentCompanyValidation = true;
  }
}
validateAssociateAutocomplete(field: string, fieldValidate: string) {
}
// getting initial values of typeAhead dropDowns
initialAssociates(field?: string) {
  if ( this.companyLeaderShip[field].name === '') {
      if (field === 'hrLeader') {
            this.associateService.getAllAssociatesFilter('a', 'initial', 'HR Manager').subscribe((data) => {
                this.autoCompleteAssociateHrLeader = data;
            }, ( error) => {
            });
    } else if (field === 'companyLeader') {
          this.associateService.getAllAssociatesFilter('a', 'initial', 'OpCo Manager').subscribe((data) => {
              this.autoCompleteAssociateCompanyleader = data;
          }, ( error) => {
          });
    } else if (field === 'financeLeader') {
          this.associateService.getAllAssociatesFilter('a', 'initial', '').subscribe((data) => {
              this.autoCompleteAssociateFinanceLeader = data;
          }, ( error) => {
          });
    } else if (field === 'digitalLeader') {
          this.associateService.getAllAssociatesFilter('a', 'initial', '').subscribe((data) => {
              this.autoCompleteAssociateDigitalLeader = data;
          }, ( error) => {
          });
    } else if (field === 'legalLeader') {
      this.associateService.getAllAssociatesFilter('a', 'initial', '').subscribe((data) => {
          this.autoCompleteAssociateLegalLeader = data;
      }, ( error) => {
      });
    }  else if (field === 'itLeader') {
      this.associateService.getAllAssociatesFilter('a', 'initial', '').subscribe((data) => {
          this.autoCompleteAssociateItLeader = data;
      }, ( error) => {
      });
    } else if (field === 'marketingLeader') {
      this.associateService.getAllAssociatesFilter('a', 'initial', '').subscribe((data) => {
          this.autoCompleteAssociateMarketingLeader = data;
      }, ( error) => {
      });

    } else if (field === 'supplyChainLeader') {
      this.associateService.getAllAssociatesFilter('a', 'initial', '').subscribe((data) => {
          this.autoCompleteAssociatesupplyChainLeader = data;
      }, ( error) => {
      });
    } else if (field === 'categoryManager') {
      this.associateService.getAllAssociatesFilter('a', 'initial', '').subscribe((data) => {
          this.autoCompleteAssociatecategoryManager = data;
      }, ( error) => {
      });
    } else if (field === 'complianceOfficer') {
      this.associateService.getAllAssociatesFilter('a', 'initial', '').subscribe((data) => {
          this.autoCompleteAssociateComplianceOfficer = data;
      }, ( error) => {
      });
    }
  }
}

initialOrganizations() {
  this.organizationService.getAllOrganizationsFilter('a').subscribe((data) => {
      this.autoCompleteOrganization = data;
  }, (error) => {
  });
}

managerTyped(fieldName: string) {
  this.keyCounter++;
  if (fieldName !== 'hrTeam') {
    this.companyLeaderShip[fieldName].id = '';
    this.companyLeaderShip[fieldName].groupId = '';
  }
if (fieldName === 'hrLeader') {
    if (this.keyCounter >= 3) {
        this.associateService.getAllAssociatesFilter(this.companyLeaderShip[fieldName].name, '' , 'HR Manager' ).subscribe((data) => {
            this.autoCompleteAssociateHrLeader = data;
        }, ( error) => {
        });
        this.keyCounter = 0 ;
        }
} else if (fieldName === 'companyLeader') {
  if (this.keyCounter >= 3) {
      this.associateService.getAllAssociatesFilter(this.companyLeaderShip[fieldName].name, '' , 'OpCo Manager').subscribe((data) => {
          this.autoCompleteAssociateCompanyleader = data;
      }, ( error) => {
      });
      this.keyCounter = 0 ;
      }
} else if (fieldName === 'financeLeader') {
  if (this.keyCounter >= 3) {
      this.associateService.getAllAssociatesFilter(this.companyLeaderShip[fieldName].name, '', '').subscribe((data) => {
          this.autoCompleteAssociateFinanceLeader = data;
      }, ( error) => {
      });
      this.keyCounter = 0 ;
      }
} else if (fieldName === 'digitalLeader') {
  if (this.keyCounter >= 3) {
      this.associateService.getAllAssociatesFilter(this.companyLeaderShip[fieldName].name, '', '').subscribe((data) => {
          this.autoCompleteAssociateDigitalLeader = data;
      }, ( error) => {
      });
      this.keyCounter = 0 ;
      }
} else if (fieldName === 'legalLeader') {
  if (this.keyCounter >= 3) {
      this.associateService.getAllAssociatesFilter(this.companyLeaderShip[fieldName].name, '', '').subscribe((data) => {
          this.autoCompleteAssociateLegalLeader = data;
      }, ( error) => {
      });
      this.keyCounter = 0 ;
      }
}  else if (fieldName === 'itLeader') {
  if (this.keyCounter >= 3) {
      this.associateService.getAllAssociatesFilter(this.companyLeaderShip[fieldName].name, '', '').subscribe((data) => {
          this.autoCompleteAssociateItLeader = data;
      }, ( error) => {
      });
      this.keyCounter = 0 ;
      }
}  else if (fieldName === 'marketingLeader') {
  if (this.keyCounter >= 3) {
      this.associateService.getAllAssociatesFilter(this.companyLeaderShip[fieldName].name, '', '').subscribe((data) => {
          this.autoCompleteAssociateMarketingLeader = data;
      }, ( error) => {
      });
      this.keyCounter = 0 ;
      }
  } else if (fieldName === 'supplyChainLeader') {
      if (this.keyCounter >= 3) {
          this.associateService.getAllAssociatesFilter(this.companyLeaderShip[fieldName].name, '', '').subscribe((data) => {
              this.autoCompleteAssociatesupplyChainLeader = data;
          }, ( error) => {
          });
          this.keyCounter = 0 ;
      }
  } else if (fieldName === 'categoryManager') {
      if (this.keyCounter >= 3) {
          this.associateService.getAllAssociatesFilter(this.companyLeaderShip[fieldName].name, '', '').subscribe((data) => {
              this.autoCompleteAssociatecategoryManager = data;
          }, ( error) => {
          });
      }
  } else if (fieldName === 'hrTeam') {
    if (this.keyCounter >= 3) {
      this.associateService.getAllAssociatesFilter(this.associateSearchHrTeam, '', 'HR Manager').subscribe((data) => {
          this.autoCompleteAssociateHrTeam = data;
      }, ( error) => {
      });
  }
  } else if (fieldName === 'complianceOfficer') {
    if (this.keyCounter >= 3) {
        this.associateService.getAllAssociatesFilter(this.companyLeaderShip[fieldName].name, '', '').subscribe((data) => {
            this.autoCompleteAssociateComplianceOfficer = data;
        }, ( error) => {
        });
    }
}

}

removeAssociate(associate) {
  const dialogRef = this.dialog.open(DeletePopupComponent, {
    width: '400px',
    data: {title:'You want to remove this Associate?'}
  });
  dialogRef.afterClosed().subscribe(result => {
    if (result === 'Proceed') {
      let associateId = associate._id;
      this.selectedAssociates = this.selectedAssociates.filter(assc => {
        if (assc._id !== associateId) {
          return assc;
        }
      });
      let IdIndex = this.organization.companyLeaderShip.hrTeamIds.indexOf(associateId);
      this.organization.companyLeaderShip.hrTeamIds.splice(IdIndex,1);
      this.update('edit',null,'hrTeam');
    }
  })
}

clickDropDown(recievedAssociate: any, cardObj: string, field?) {
  if (field === 'hrTeam') {
    if (this.organization.companyLeaderShip.hrTeamIds.indexOf(recievedAssociate._id) > -1) {
      this.toastService.error('Duplicate Associate');
    } else {
      this.selectedAssociates.push(recievedAssociate);
      this.organization.companyLeaderShip.hrTeamIds.push(recievedAssociate._id);
      this.update('edit',null,'hrTeam',recievedAssociate._id);
    }

  } else {
    this.companyLeaderShip[cardObj].name = recievedAssociate.personalInformation.fullName;
    this.companyLeaderShip[cardObj].id = recievedAssociate._id;
    this.companyLeaderShip[cardObj].groupId = recievedAssociate.groupId;
  }

}

clickDropDownOrganization(field: string) {
  this.company[field].name = this.selectedParentCompany.company.companyName;
  this.company[field].id = this.selectedParentCompany._id;
  this.company[field].companyId = this.selectedParentCompany.company.companyId;
}

organizationTyped(fieldName: string) {
  this.keyCounterOrg++;

  this.company[fieldName].companyId = '';
  this.company[fieldName].id = '';

  if (this.keyCounterOrg >= 3) {
      this.organizationService.getAllOrganizationsFilter(this.company.parentCompany.name).subscribe((data) => {
          this.autoCompleteOrganization = data;
      }, ( error) => {});
      this.keyCounterOrg = 0 ;
      }
}
// code for uploading image
onFileChange(event) {
  const reader = new FileReader();
  const reader2 = new FileReader();
        if (event.target.files && event.target.files.length > 0) {
            const file = event.target.files[0];
            if ( event.target.files[0].type === 'image/png' || event.target.files[0].type === 'image/jpg'
            || event.target.files[0].type === 'image/jpeg') {
            reader.readAsDataURL(file);
            reader.onload = (onLoadResult) => {
                this.tempBase64Img = reader.result;
                this.organization.avatar = {
                    filename: file.name,
                    filetype: file.type,
                    imageData: reader.result.split(',')[1]
                };
                const imageElem = new Image();
                imageElem.onload = (imageOnloadResult) => {
                    // if (imageOnloadResult['path'][0]['width'] < 500 && imageOnloadResult['path'][0]['height'] < 150) {
                    //     this.openCropImageDialog(reader.result);
                    // } else {
                        const curWidth = imageOnloadResult['path'][0]['width'];
                        const curHeight = imageOnloadResult['path'][0]['height'];
                        let newWidth = curWidth;
                        let newHeight = curHeight;
                        const requiredRatio = 500 / 150;
                        const currentRatio = curWidth / curHeight;
                        if (currentRatio > requiredRatio) {
                            newHeight = curWidth / requiredRatio;
                        } else {
                            newWidth = curHeight * requiredRatio;
                        }
                        // tslint:disable-next-line:max-line-length
                        this.ng2ImgToolsService.resizeExactFillImage(event.target.files[0], newWidth, newHeight, '#ffffff').subscribe(result => {
                            reader2.readAsDataURL(result);
                            reader2.onload = () => {
                                this.openCropImageDialog(reader2.result);
                            }
                        }, err => {
                            console.log(err);
                        });
                    // }
                  };
                imageElem.src = onLoadResult['target']['result'];
            };
          } else {
            this.toastService.error(this.errors.File['404']);
          }
        }
      }
// image crop functionality
openCropImageDialog(imageDataEvent): void {
  const dialogRef = this.dialog.open(ImageCropDialogComponent, {
      width: '500px',
      data: { event: imageDataEvent }
  });
  dialogRef.afterClosed().subscribe(result => {
      this.organization.avatar.imageData = result;
      this.tempBase64Img = result;
  });
}
// whole organization validation boolean
validateOrganization() {
  if (this.organization.company.validated === 0 || this.organization.companyLeaderShip.validated === 0 ||
    this.organization.companyOverview.validated === 0 ||  this.organization.companySize.validated === 0) {
    this.organization.validated = 0;
  } else if (this.organization.company.validated === 1 || this.organization.companyLeaderShip.validated === 1 ||
    this.organization.companyOverview.validated === 1 ||  this.organization.companySize.validated === 1) {
      this.organization.validated = 1 ;
    }  else {
      this.organization.validated = 2;
    }
}
tabChange(val: any) {
  this.tabs = val;
}

// send any notification to all four company Leaders
sendNotificationToCompanyLeaders(notificationMessage: string, notificationUrl) {
  let peopleToSendNotification = {};
  peopleToSendNotification[this.organization.companyLeaderShip.companyLeader.id] = this.organization.companyLeaderShip.companyLeader.id;
  peopleToSendNotification[this.organization.companyLeaderShip.hrLeader.id] = this.organization.companyLeaderShip.hrLeader.id;
  peopleToSendNotification[this.organization.companyLeaderShip.financeLeader.id] = this.organization.companyLeaderShip.financeLeader.id;
  peopleToSendNotification[this.organization.companyLeaderShip.digitalLeader.id] = this.organization.companyLeaderShip.digitalLeader.id;
  this.organization.companyLeaderShip.hrTeamIds.forEach(element => {
    peopleToSendNotification[element] = element;
  });
  for ( let leaderId in peopleToSendNotification) {
    if (peopleToSendNotification.hasOwnProperty(leaderId)) {
        this.notificationService.sendNotification(leaderId,
      notificationMessage, 'Organization', notificationUrl);
      }
  }
}
// swipe for mobile
swipeTabs(event) {
  if (window.innerWidth < 768 ) {
    let tabsArray = [];
    let indexLimit = 3;
    // if (this.isAssociate) {
    //   tabsArray = ['profile', 'sites' , 'teams' ];
    //   indexLimit  = 2 ;
    // } else  {
    //   tabsArray = ['profile', 'sites', 'legal' , 'teams'];
    //   indexLimit  = 3;
    // }

    tabsArray = ['profile', 'sites' , 'teams' ];
    indexLimit  = 2 ;


      let currIndex = tabsArray.indexOf(this.tabs);
      if (event === 'swipeleft' ) {
          currIndex = currIndex + 1;
      } else if ( event === 'swiperight' ) {
          currIndex = currIndex - 1;
      }
      if (currIndex < 0 ) {
          currIndex = 0;
      } else if (currIndex > indexLimit ) {
          currIndex = indexLimit;
      }
      this.tabChange(tabsArray[currIndex]);
      let list = document.getElementById('tabsUl'),
      targetLi = document.getElementById(tabsArray[currIndex]);
      list.scrollLeft = (targetLi.offsetLeft - 50);
  }
}

backBtnClick() {
  this._location.back();
}

// Remove Legal Entity From Organization
removeFromOrganization(legalEntityId) {
  const dialogRef = this.dialog.open(DeletePopupComponent, {
    width: '400px',
    data: {title:'You want to remove this?'}
  });

  dialogRef.afterClosed().subscribe(response =>{
    if(response === 'Proceed'){
      this.organizationService.removeLegalEntityFromOrganization(legalEntityId, this.organizationId).subscribe((data) => {
        // this.router.navigate(['/home/organization/profile/view', this.organizationId]);
        this.organization.legalEntities = this.organization.legalEntities.filter(ent => {
          if (ent.legalEntityId !== legalEntityId) {
            return ent;
          }
        });
        this.toastService.success();
       } , (error) => {
        this.toastService.error(this.errors.Server['501']);
        });
    }
  })
}

businessModelArray() {
  let tempArray = [];
  if (this.businessModelDistributionCheckBox) {
    tempArray.push('Distribution');
  } if (this.businessModelProjectBasedCheckBox) {
    tempArray.push('Project Based');
  } if (this.businessModelKeyAccountsCheckBox) {
    tempArray.push('Key Accounts');
  }
  this.companyOverview.businessModel = Object.assign([], tempArray);
}

validateCustomerSales() {
  let installers = this.companySize.customerSales.installers;
  let industry = this.companySize.customerSales.industry;
  let infrastructure = this.companySize.customerSales.infrastructure;
  let others = this.companySize.customerSales.others;
  let tempCustomerSalesSum = installers + industry + infrastructure + others;
  if (tempCustomerSalesSum !== 100 ) {
    this.customerSales = false;
  } else {
    this.customerSales = true;
  }
}

validateProductSales() {
  let cablesAndWires = this.companySize.productSales.cablesAndWires;
  let buildingAutomationAndConstruction = this.companySize.productSales.buildingAutomationAndConstruction;
  let infrastructure = this.companySize.productSales.infrastructure;
  let lighting = this.companySize.productSales.lighting;
  let industrialAutomation = this.companySize.productSales.industrialAutomation;
  let hvacAndRenewableEnergy = this.companySize.productSales.hvacAndRenewableEnergy;
  let safetyToolsAndEngineeringSupplies = this.companySize.productSales.safetyToolsAndEngineeringSupplies;
  let specialities = this.companySize.productSales.specialities;
  let others = this.companySize.productSales.others;
  let tempProductSalesSum = cablesAndWires +
  industrialAutomation + infrastructure
  + buildingAutomationAndConstruction + lighting
  + hvacAndRenewableEnergy +
  safetyToolsAndEngineeringSupplies
  + specialities + others;
  if (tempProductSalesSum !== 100 ) {
    this.productSales = false;
  } else {
    this.productSales = true;
  }
}

detectChanges(old, new_, parent?) {
  if ((old === new_ && old) || !old) {
      return;
  }
  const properties = Object.keys(old);

  if (Array.isArray(old)) {
      return;
  }
  for (let pr of properties) {
      // tslint:disable-next-line:max-line-length
      if (isString(old[pr]) && old[pr] !== new_[pr] && pr !== 'id' && pr !=="activeStatus" && pr !== 'groupId' && pr !== 'validated' && pr !== 'lastValidatedBy' && pr !== 'lastEditedBy' && pr !== 'avatarUrl') {
          // tslint:disable-next-line:max-line-length
          if ((old[pr].indexOf('00:00') !== -1  || new_[pr].indexOf('00:00') !==-1) && moment(old[pr]).format('DD MMM YYYY') !== moment(new_[pr]).format('DD MMM YYYY') ) {
              this.fieldChanges.push({ label: this.getFormalCardName(parent) + ' ' + this.getFormalCardName(pr), oldValue: old[pr] ? moment(old[pr]).format('DD MMM YYYY') : '', newValue: new_[pr] ? moment(new_[pr]).format('DD MMM YYYY') : '' });
          } else if( !(old[pr].indexOf('00:00') !== -1  || new_[pr].indexOf('00:00') !==-1) ) {
              this.fieldChanges.push({ label: this.getFormalCardName(parent) + ' ' + this.getFormalCardName(pr), oldValue: old[pr], newValue: new_[pr] });
          }
      } else if (!isString(old[pr]) && pr !== 'validated' && pr !== 'id' && pr !== 'groupId' && pr !== 'lastValidatedBy' && pr !== 'lastEditedBy') {
          this.detectChanges(old[pr], new_[pr], pr);
      } else {
      }
  }
}


getFormalCardName(cardName: string) {
  switch (cardName) {
      case 'company': {
       return 'Basic Details'
      }
      case 'companyLeaderShip': {
        return 'Leadership'
      }
      case 'companyOverview': {
        return 'Business Overview'
      }
      case 'companySize': {
        return 'Key Stats'
      }
      case 'companyLeader': {
         return 'Company Leader'
      }
      case 'hrLeader': {
        return 'HR Leader'
      }
      case 'financeLeader': {
        return 'Finance Leader'
      }
      case 'digitalLeader': {
        return 'Digital Leader'
      }
      case 'legalLeader': {
        return 'Legal Leader'
      }
      case 'supplyChainLeader': {
        return 'Supply Chain Leader'
      }
      case 'categoryManager': {
        return 'Category Management Leader'
      }
      case 'itLeader': {
        return 'IT Leader'
      }
      case 'marketingLeader': {
        return 'Marketing Leader'
      }
      case 'companyName': {
        return 'Name'
      }
      case 'companyType': {
        return 'Company Type'
      }
      case 'soa': {
        return 'SOA'
      }
      case 'parentCompany': {
        return 'Parent Company'
      }
      case 'countryOfReference': {
        return 'Country of Reference'
      }
      case 'companyOverview': {
        return ''
      }
      case 'industrySegment': {
        return 'Industry Segments'
      }
      case 'marketsServed': {
        return 'Markets Served'
      }
      case 'customerTypes': {
        return 'Customer Types'
      }
      case 'totalSales': {
        return 'Sales'
      }
      case 'joinDate':{
        return 'Join Date'
      }
      case 'cityOfReference': {
        return 'City of Reference'
      }
      case undefined: {
        return ''
      }
      case cardName: {
        return cardName;
      }
   }
}



sortData(sort: Sort,tab) {
  let data = [];
  if (tab === 'legalEntity') {
     data = Object.assign([],this.organization.legalEntities);
  } else if (tab === 'hrTeam') {
     data = Object.assign( [], this.selectedAssociates);
  }
  if (!sort.active || sort.direction === '') {
    if (tab === 'legalEntity') {
      this.legalEntityList = data;
      return;
    } else if (tab === 'hrTeam') {
      this.selectedAssociates = data;
    }
  }
  let isAsc = sort.direction === 'asc';
  let sortedList = data.sort((a, b) => {
    if (tab === 'legalEntity') {
      switch (sort.active) {
        case 'name': return this.compare(a.name.toLowerCase(), b.name.toLowerCase(), isAsc);
        case 'country': return this.compare(a.country.toLowerCase(), b.country.toLowerCase(), isAsc);
        case 'status': return this.compare(a.status.toLowerCase(), b.status.toLowerCase(), isAsc);
        default: return 0;
      }
    } else if (tab === 'hrTeam') {
      switch (sort.active) {
        case 'name': return this.compare(a.personalInformation.fullName.toLowerCase(), b.personalInformation.fullName.toLowerCase(), isAsc);
        case 'jobCategory': return this.compare(a.jobDescription.jobCategory.toLowerCase(), b.jobDescription.jobCategory.toLowerCase(), isAsc);
        case 'localId': return this.compare(a.localId.toLowerCase(), b.localId.toLowerCase(), isAsc);
        default: return 0;
      }
    }
  });
  if (tab === 'legalEntity') {
    this.legalEntityList = sortedList;
  } else if (tab === 'hrTeam') {
    this.selectedAssociates  =  sortedList;
  }

}

  compare(a, b, isAsc) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  getServerData(event) {
    this.startMemberIndex = event.pageIndex * event.pageSize;
  }


  removeAvatar(){
    this.company.avatarUrl = 'uploads/assets/img/profile/company_placeholder.svg';
    this.tempBase64Img = undefined;
  }
}

